//import axios from "axios";
import api from "../../../../../api";

export function requestGetMakesCar() {
    return api.get('/makes');
}
export function requestGetModelsCar(id) {
    return api.get('/makemodels/' + id);
}
export function requestGetGenerationsCar(id) {
    return api.get('/modelgenerations/' + id);
}

export function requestGetMotorsCar(generationId) {
    return api.get('/generationmotor/' + generationId);
}
